<div *ngIf="projects">
  <div class="header">
    <div class="title">Merging portfolios</div>
    <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
  <form [formGroup]="addProjectForm" (submit)="addProjectForm.invalid ? null : save()" *ngIf="!saving; else loading">
    <ng-container *ngIf="projects?.length; else MergeInPorfolio">
      <p class="mb-3">There is more than one Portfolio selected.</p>
      <p class="mb-5">To proceed, select which one should remain as a portfolio.</p>
      <div class="flex flex-col gt-xs:flex-row">
        <mat-form-field class="flex-auto gt-xs">
          <mat-label>Portfolio</mat-label>
          <mat-select formControlName="selectedProject" placeholder="--Select--" data-cy="pipeline-type-select">
            <mat-option *ngFor="let project of projects" [value]="project.id">
              {{ project.title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-template #MergeInPorfolio>
      <p class="mb-3">
        Are you sure that you wish merge {{ childProjects.length }}
        {{
          childProjects?.length
            | i18nPlural
              : {
                  '=1': 'deal',
                  other: 'deals'
                }
        }}
        into <strong>{{ parentProject?.title }}</strong> portfolio.
      </p>
    </ng-template>

    <p class="mb-5" *ngIf="!loadingChildren && childIds?.length">New structure after the merge.</p>
    <p
      class="mt-10 text-red"
      *ngIf="addProjectForm.get('childIds').touched && addProjectForm.get('childIds').hasError('required')"
    >
      Unable to load Deals at this moment. Please try again later...
    </p>

    <div class="new-structure-preview" *ngIf="!loadingChildren && childIds?.length">
      <p class="new-structure-preview__parent">
        {{ parentProject?.title }}
      </p>

      <p></p>
      <p class="new-structure-preview__child" *ngFor="let child of childProjects">
        <mat-icon [svgIcon]="'subdirectory_arrow_right'"></mat-icon> {{ child?.title }}
      </p>
    </div>

    <div class="actions">
      <div class="formatting"></div>
      <div class="buttons">
        <button class="discard-button" mat-button type="button" (click)="discard()">
          <span>Cancel</span>
        </button>
        <button
          class="send-button"
          mat-flat-button
          type="submit"
          [color]="'primary'"
          [disabled]="loadingChildren || addProjectForm.invalid"
          data-cy="save-portfolio"
        >
          <mat-progress-spinner *ngIf="loadingChildren" [diameter]="24" [mode]="'indeterminate'">
          </mat-progress-spinner>
          <span *ngIf="!loadingChildren">Confirm merge</span>
        </button>
      </div>
    </div>
  </form>

  <ng-template #loading>
    <div class="flex items-center" style="flex-direction: column; padding: 80px 50px">
      <mat-progress-spinner [diameter]="75" [mode]="'indeterminate'"> </mat-progress-spinner>
      <div style="margin-top: 40px">This may take up to a few minutes.</div>
    </div>
  </ng-template>
</div>
